type UmamiTracker = {
    track: (eventName: string, data?: Record<string, unknown>) => void;
};

declare global {
    interface Window {
        umami?: UmamiTracker;
    }
}

// Generic event tracker
export const trackEvent = (eventName: string, data?: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && window.umami) {
        window.umami.track(eventName, data);
    }
};

// Specific event helpers
export const trackContactForm = (status: 'success' | 'error', message?: string) => {
    trackEvent('contact_form_submit', { status, message });
};

export const trackSocialClick = (platform: string) => {
    trackEvent('social_click', { platform });
};

export const trackHeroAction = (action: string) => {
    trackEvent('hero_cta_click', { action });
};

export const trackMenuToggle = (state: 'open' | 'close') => {
    trackEvent('mobile_menu_toggle', { state });
};

export const trackNavClick = (section: string) => {
    trackEvent('nav_click', { section });
};

export const track404 = (path: string) => {
    trackEvent('404_error', { path });
};
